import React from 'react';
import { CardPaymentReceipt } from 'cardPayment/types';
import { formatPrice } from 'utils/formating';

const content = {
  paid: {
    title: 'Payment successful',
    message: "Thank you. Your subscription is now active, and we've emailed your invoice receipt.",
  },
  received: {
    title: 'Payment received',
    message:
      "Thank you, we've received your payment. Your subscription is being confirmed and will appear in your account shortly. We'll email your invoice receipt.",
  },
};

type Props = {
  receipt: CardPaymentReceipt;
  buttonText?: string;
  onButtonClick?: () => void;
};

export const CardPaymentResult: React.FC<Props> = ({ receipt, buttonText, onButtonClick }) => {
  const { title, message } = content[receipt.outcome];

  return (
    <div className={'ConfirmationBox CardPaymentResult ' + (receipt.outcome === 'paid' ? 'Paid' : 'Received')}>
      <span className="ConfirmIcon"></span>
      <h2>{title}</h2>
      <p>{message}</p>

      {receipt.items.length > 0 && (
        <ul className="CPRItems">
          {receipt.items.map((item, index) => (
            <li key={index}>
              <span className="CPRTitle">{item.title}</span>
              <span className="CPRDetail">{item.detail}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="CPRTotal">
        <span>Total paid</span>
        <span>£{formatPrice(receipt.total)}</span>
      </div>

      {buttonText && onButtonClick && (
        <button type="button" onClick={onButtonClick} className="Btn BtnOrange">
          {buttonText}
        </button>
      )}
    </div>
  );
};
